/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Why a billing period cannot be given precedence over the entitlements in its window.
 */
export type PrecedenceRefusal = typeof PrecedenceRefusal[keyof typeof PrecedenceRefusal];


export const PrecedenceRefusal = {
  already_projected: 'already_projected',
  period_expired: 'period_expired',
  blockers_not_started: 'blockers_not_started',
} as const;
